/* Product imagery — five behaviours, one file.

     GALLERY SWIPE  swipe the product page photo to change it (touch)
     GALLERY DRAG   hold and drag the product page photo (mouse and pen)
     LIGHTBOX       tap a product page photo to see it large
     CARD SWIPE     swipe a tile in any grid to see its other shots
     PEEK           press and hold a tile to enlarge it

   Everything is delegated off document. Handlers bound directly to images
   would die with the markup when the product page swaps colourway or a grid
   re-renders, and the overlays would then point at elements that no longer
   exist.

   TWO KINDS OF TILE, ONE SET OF BEHAVIOURS
   A picture box is either .card-image (a product card) or .trend-im (a tile
   in the trend row). They are styled by different files and sit in different
   grids, but they hold the same three things — a .card-track scroller,
   .card-dots and the desktop .card-arrow controls — and they must behave
   identically, because to a shopper they are the same object. The selector is
   declared once, below, rather than written out at each of the six places it
   is needed; that is what stopped the two drifting apart the first time.

   CARD SWIPE IS NOT SCRIPTED. It is a native scroll-snap track built in the
   Liquid; the browser drives it. What remains here is the reporting around it
   — keeping the dots honest and driving the desktop arrows. An earlier
   version reimplemented the gesture by hand and spent most of its length
   arbitrating with the peek and the tile's own link over who owned a touch. A
   scroll is not a click, so that whole class of conflict is gone. */

var BT_BOX = '.card-image, .trend-im';
var BT_PIC = '.card-image img, .trend-im img';
var BT_TILE = '.card, .trend';

/* ---------------- Lightbox + product page gallery ---------------- */
(function(){
  var box = document.querySelector('[data-lightbox]');
  if(!box) return;

  var img     = box.querySelector('[data-lb-img]');
  var countEl = box.querySelector('[data-lb-count]');
  var prevBtn = box.querySelector('[data-lb-prev]');
  var nextBtn = box.querySelector('[data-lb-next]');

  var shots = [];
  var at = 0;
  var lastFocus = null;
  var justSwiped = false;
  var galSwiped  = false;

  /* v131: a video slide's still is not a photo. It is left out of the photo
     viewer so the photo viewer's count and arrows stay about photos. */
  function slides(){
    return Array.prototype.slice.call(document.querySelectorAll('.gallery-slide:not([data-video-slide]) img'));
  }

  function collect(){
    shots = slides().map(function(el){
      return { src: el.currentSrc || el.src, alt: el.alt || '' };
    });
  }

  function show(i){
    if(!shots.length) return;
    at = (i + shots.length) % shots.length;
    img.src = shots[at].src;
    img.alt = shots[at].alt;
    countEl.textContent = shots.length > 1 ? (at + 1) + ' / ' + shots.length : '';
    var many = shots.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
  }

  function open(i){
    collect();
    if(!shots.length) return;
    lastFocus = document.activeElement;
    box.hidden = false;
    box.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    show(i);
    requestAnimationFrame(function(){ box.classList.add('is-open'); });
    box.querySelector('[data-lb-close]').focus();
  }

  function close(){
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    setTimeout(function(){ box.hidden = true; img.removeAttribute('src'); }, 180);
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- Product video (v131) ----
     The gallery is square, so a video slide shows its still cropped, with
     "Tap to play". A tap opens the video full screen at its own shape (a 9:16
     clip stays 9:16), playing straight away.
     ALWAYS SILENT (v132, 25 Oct 2026, Dev: "all video thats upload in product
     page should be muted" -> "Always silent"). The video is muted, the mute
     and volume controls are hidden (lightbox.css), and anything that turns
     sound on is turned straight back off. Muted video also autoplays on
     every browser, so there is no sound-refused fallback any more. Closing stops it and
     drops the file, so nothing keeps downloading or playing. galSwiped is the
     same flag the photo viewer uses, so a swipe or drag never opens it. */
  var vbox = null, vEl = null, vLast = null;

  function vBuild(){
    vbox = document.createElement('div');
    vbox.className = 'vbox';
    vbox.hidden = true;
    vbox.setAttribute('role', 'dialog');
    vbox.setAttribute('aria-modal', 'true');
    vbox.setAttribute('aria-label', 'Product video');
    vbox.innerHTML =
      '<button type="button" class="vbox-x" data-vbox-close aria-label="Close video">&times;</button>' +
      '<video class="vbox-v" muted playsinline controls preload="auto" controlslist="nodownload noplaybackrate" disablepictureinpicture></video>';
    document.body.appendChild(vbox);
    vEl = vbox.querySelector('video');
    vEl.muted = true;
    vEl.addEventListener('volumechange', function(){
      if(!vEl.muted) vEl.muted = true;
    });
  }

  function vOpen(slide){
    var src = slide.getAttribute('data-video-src');
    if(!src) return;
    if(!vbox) vBuild();
    vLast = document.activeElement;
    /* The 1080p mp4 plays first. Tested on the Chairman clip (7 s): it starts
       at once and is sharp, while the HLS stream started slower and never
       climbed above 480p before the clip ended, which undersells the frame.
       The stream stays as the fallback if the mp4 fails to load. */
    var hls = slide.getAttribute('data-video-hls') || '';
    var tried = false;
    vEl.onerror = function(){
      if(tried || !hls || vbox.hidden || !vEl.canPlayType('application/vnd.apple.mpegurl')) return;
      tried = true;
      vEl.src = hls;
      var r = vEl.play(); if(r && r.catch) r.catch(function(){});
    };
    vEl.poster = slide.getAttribute('data-video-poster') || '';
    vEl.muted = true;
    vEl.src = src;
    vbox.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ vbox.classList.add('is-open'); });
    var p = vEl.play();
    if(p && p.catch) p.catch(function(){});
    vbox.querySelector('[data-vbox-close]').focus();
  }

  function vClose(){
    if(!vbox || vbox.hidden) return;
    vEl.onerror = null;
    vEl.pause();
    vEl.removeAttribute('src');
    vEl.load();
    vbox.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function(){ vbox.hidden = true; }, 180);
    if(vLast && vLast.focus) vLast.focus();
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && vbox && !vbox.hidden) vClose();
  });

  document.addEventListener('click', function(e){
    if(vbox && !vbox.hidden){
      if(e.target.closest('[data-vbox-close]') || e.target === vbox){ vClose(); }
      return;
    }
    /* With a mouse or pen, the drag code captures the pointer on the gallery
       box, so the click lands on [data-gallery] itself rather than the slide
       under the cursor. Read the showing slide off the box in that case. */
    var gal = (e.target.matches && e.target.matches('[data-gallery]'))
      ? e.target.querySelector('.gallery-slide[data-active="true"]') : null;
    var vs = e.target.closest('[data-video-slide]') ||
      (gal && gal.hasAttribute('data-video-slide') ? gal : null);
    if(vs){
      e.preventDefault();
      if(galSwiped) return;
      vOpen(vs);
      return;
    }
    var shot = e.target.closest('.gallery-slide img') ||
      (gal && !gal.hasAttribute('data-video-slide') ? gal.querySelector('img') : null);
    if(shot){
      e.preventDefault();
      if(galSwiped) return;
      open(slides().indexOf(shot));
      return;
    }
    if(e.target.closest('[data-lb-close]')){ close(); return; }
    if(e.target.closest('[data-lb-prev]')){ show(at - 1); return; }
    if(e.target.closest('[data-lb-next]')){ show(at + 1); return; }

    if(box.hidden) return;
    if(justSwiped) return;
    if(e.target.closest('[data-lb-stage]') || e.target === box){ close(); }
  });

  document.addEventListener('keydown', function(e){
    if(box.hidden) return;
    if(e.key === 'Escape'){ close(); }
    else if(e.key === 'ArrowLeft'){ show(at - 1); }
    else if(e.key === 'ArrowRight'){ show(at + 1); }
  });

  var x0 = null, y0 = null;
  box.addEventListener('touchstart', function(e){
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; justSwiped = false;
  }, {passive:true});
  box.addEventListener('touchend', function(e){
    if(x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5){
      show(dx < 0 ? at + 1 : at - 1);
      justSwiped = true;
      setTimeout(function(){ justSwiped = false; }, 350);
    }
    x0 = y0 = null;
  }, {passive:true});

  /* ---- Which photo is showing ----
     The dots are the single source of truth, and clicking one is how BOTH
     gestures below change the picture. The section's own goTo() lives in a
     closure and cannot be called from here; going through the dot means the
     dots, the thumbnails, the swipe and the drag can never end up disagreeing
     about which photo is on screen. The dots are display:none on a laptop —
     a programmatic .click() does not care. */
  function galDots(){
    return Array.prototype.slice.call(document.querySelectorAll('[data-gallery-dots] button'));
  }
  function galNow(d){
    for(var i = 0; i < d.length; i++){
      if(d[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  /* ---- Touch: swipe the product page gallery ---- */
  var gx = null, gy = null;

  document.addEventListener('touchstart', function(e){
    if(!e.target.closest('[data-gallery]')) return;
    gx = e.touches[0].clientX; gy = e.touches[0].clientY;
    galSwiped = false;
  }, {passive:true});

  document.addEventListener('touchend', function(e){
    if(gx === null) return;
    var dx = e.changedTouches[0].clientX - gx;
    var dy = e.changedTouches[0].clientY - gy;
    gx = gy = null;
    if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

    var d = galDots();
    if(d.length < 2) return;

    var now = galNow(d);
    /* Stops at the ends rather than looping. A gallery that wraps round leaves
       people unsure whether they have seen everything. */
    var next = dx < 0 ? now + 1 : now - 1;
    if(next < 0 || next >= d.length) return;

    d[next].click();
    galSwiped = true;
    setTimeout(function(){ galSwiped = false; }, 350);
  }, {passive:true});

  /* ---- Mouse and pen: hold and drag the product page gallery ----

     This file used to say a mouse drag on a photo "is not something anyone
     does on purpose". That was wrong: anyone who has used a phone expects a
     picture to follow the pointer, and on a laptop the dots are hidden, so
     the thumbnail strip was the only way through the shots.

     Touch is deliberately excluded — the swipe above already owns phones, and
     running both would fight over the same gesture.

     The photo tracks the pointer live: the neighbour rides in behind it, the
     ends rubber-band so it is obvious there is nothing further, and letting
     go past about an eighth of the width commits. galSwiped is the same flag
     the touch swipe uses, so finishing a drag never also opens the lightbox.

     No preventDefault on pointerdown, on purpose: it would suppress the click
     that opens the lightbox on a plain, motionless click. Native image
     dragging is already off (draggable="false" in the Liquid) and text
     selection is killed by .is-dragging in pdp-compact.css. */
  var pX = null, pY = null, pId = null;
  var pStage = null, pSlides = [], pIdx = 0, pW = 0, pOn = false;

  function clearShift(list){
    list.forEach(function(s){
      s.style.transform = '';
      s.classList.remove('is-peeking');
    });
  }

  document.addEventListener('pointerdown', function(e){
    if(e.pointerType === 'touch') return;
    if(e.button !== 0) return;
    var stage = e.target.closest('[data-gallery]');
    if(!stage) return;
    if(galDots().length < 2) return;

    pStage = stage;
    pSlides = Array.prototype.slice.call(stage.querySelectorAll('.gallery-slide'));
    pIdx = galNow(galDots());
    pW = stage.clientWidth || 1;
    pX = e.clientX; pY = e.clientY; pId = e.pointerId; pOn = false;
    if(stage.setPointerCapture){ try{ stage.setPointerCapture(pId); }catch(err){} }
  });

  document.addEventListener('pointermove', function(e){
    if(pX === null || e.pointerId !== pId) return;
    var dx = e.clientX - pX;

    if(!pOn){
      /* A few pixels of slop, so a slightly shaky click is still a click. */
      if(Math.abs(dx) < 6) return;
      if(Math.abs(dx) < Math.abs(e.clientY - pY)) return;
      pOn = true;
      pStage.classList.add('is-dragging');
    }

    var dir = dx < 0 ? 1 : -1;
    var n = pIdx + dir;
    var edge = (n < 0 || n >= pSlides.length);
    var shift = edge ? dx * 0.25 : dx;

    clearShift(pSlides);
    if(pSlides[pIdx]) pSlides[pIdx].style.transform = 'translateX(' + shift + 'px)';
    if(!edge && pSlides[n]){
      pSlides[n].classList.add('is-peeking');
      pSlides[n].style.transform = 'translateX(' + (shift + dir * pW) + 'px)';
    }
  });

  function galDrop(e){
    if(pX === null) return;
    if(e && e.pointerId != null && e.pointerId !== pId) return;

    var dx    = (e && typeof e.clientX === 'number') ? e.clientX - pX : 0;
    var stage = pStage, list = pSlides, from = pIdx, w = pW, dragged = pOn;

    pX = pY = pId = null; pStage = null; pOn = false;
    if(stage) stage.classList.remove('is-dragging');
    if(!dragged){ clearShift(list); return; }

    var d = galDots();
    var to = from + (dx < 0 ? 1 : -1);
    var far = Math.abs(dx) > Math.max(48, w * 0.12);

    /* A drag is never a click, however short. Without this, a nudge that does
       not commit would still land on the lightbox. */
    galSwiped = true;
    setTimeout(function(){ galSwiped = false; }, 300);

    if(!far || to < 0 || to >= d.length){
      clearShift(list);
      return;
    }

    /* The outgoing slide keeps .is-peeking so it stays visible long enough to
       finish leaving; without it the visibility flip would make it vanish on
       the spot and only half the movement would be seen. */
    if(list[to]) list[to].style.transform = '';
    if(list[from]){
      list[from].classList.add('is-peeking');
      list[from].style.transform = 'translateX(' + (dx < 0 ? -w : w) + 'px)';
    }
    d[to].click();
    setTimeout(function(){ clearShift(list); }, 320);
  }

  document.addEventListener('pointerup', galDrop);
  document.addEventListener('pointercancel', galDrop);
})();

/* ---------------- Card track: dots, arrows ---------------- */
(function(){
  function indexOf(track){
    var w = track.clientWidth;
    if(!w) return 0;
    return Math.round(track.scrollLeft / w);
  }

  function paint(track){
    var box = track.closest(BT_BOX);
    if(!box) return;
    var i = indexOf(track);

    var dots = box.querySelectorAll('[data-card-dots] i');
    for(var n = 0; n < dots.length; n++){
      dots[n].classList.toggle('is-on', n === i);
    }

    /* Hide the arrow that would do nothing. A chevron pointing at a wall is
       worse than no chevron. */
    var prev = box.querySelector('[data-card-prev]');
    var next = box.querySelector('[data-card-next]');
    var last = track.children.length - 1;
    if(prev) prev.classList.toggle('is-off', i <= 0);
    if(next) next.classList.toggle('is-off', i >= last);
  }

  /* Scroll events do not bubble, so this listens in the capture phase to catch
     them from every track on the page without binding one listener per tile.
     Painting is deferred to the next frame so a fast flick repaints once per
     frame rather than once per scroll event. */
  var queued = null;
  document.addEventListener('scroll', function(e){
    var track = e.target;
    if(!track || !track.classList || !track.classList.contains('card-track')) return;
    if(queued) return;
    queued = requestAnimationFrame(function(){
      queued = null;
      paint(track);
    });
  }, true);

  document.addEventListener('click', function(e){
    var arrow = e.target.closest('[data-card-prev], [data-card-next]');
    if(!arrow) return;
    /* The arrow sits inside the tile's link. Without both of these, nudging
       the photo would also open the product. */
    e.preventDefault();
    e.stopPropagation();

    var box = arrow.closest(BT_BOX);
    var track = box && box.querySelector('[data-card-track]');
    if(!track) return;

    var dir = arrow.hasAttribute('data-card-next') ? 1 : -1;
    track.scrollTo({ left: (indexOf(track) + dir) * track.clientWidth, behavior: 'smooth' });
  });

  /* Arrow state on first hover: until then every tile is at photo one and the
     server-rendered markup is already correct. */
  document.addEventListener('mouseover', function(e){
    var box = e.target.closest && e.target.closest(BT_BOX);
    if(!box || box.hasAttribute('data-armed')) return;
    var track = box.querySelector('[data-card-track]');
    if(!track) return;
    box.setAttribute('data-armed','1');
    paint(track);
  });
})();

/* ---------------- Peek: press and hold a tile ---------------- */
(function(){
  var HOLD = 240;
  var WARM = 100;
  var SLOP = 12;

  var layer = null, pic = null;
  var holdTimer = null, warmTimer = null;
  var open = false, blockClick = false;
  var sx = 0, sy = 0;
  var warmed = {};

  function build(){
    if(layer) return;
    layer = document.createElement('div');
    layer.className = 'peek';
    layer.hidden = true;
    pic = document.createElement('img');
    pic.className = 'peek-img';
    pic.alt = '';
    layer.appendChild(pic);
    document.body.appendChild(layer);
  }

  function warm(url){
    if(!url) return null;
    if(warmed[url]) return warmed[url];
    var pre = new Image();
    pre.src = url;
    warmed[url] = pre;
    return pre;
  }

  /* Paints from the tile's own already-decoded image so it appears on the same
     frame the hold completes, then swaps in the sharp copy once it lands. */
  function showPeek(el){
    build();
    pic.src = el.currentSrc || el.src;
    pic.alt = el.alt || '';
    layer.hidden = false;
    open = true;
    requestAnimationFrame(function(){ layer.classList.add('is-open'); });

    var url = el.getAttribute('data-peek') || '';
    if(!url) return;
    var pre = warm(url);
    if(pre.complete && pre.naturalWidth){ pic.src = url; }
    else {
      pre.addEventListener('load', function(){ if(open && pic) pic.src = url; }, {once:true});
    }
  }

  function cancelPending(){
    clearTimeout(holdTimer); holdTimer = null;
    clearTimeout(warmTimer); warmTimer = null;
  }

  function hide(){
    cancelPending();
    if(!open) return;
    open = false;
    layer.classList.remove('is-open');
    setTimeout(function(){
      if(!open && layer){ layer.hidden = true; pic.removeAttribute('src'); }
    }, 140);
  }

  document.addEventListener('touchstart', function(e){
    var el = e.target.closest(BT_PIC);
    if(!el) return;
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
    cancelPending();
    warmTimer = setTimeout(function(){ warm(el.getAttribute('data-peek')); }, WARM);
    holdTimer = setTimeout(function(){
      showPeek(el);
      blockClick = true;
    }, HOLD);
  }, {passive:true});

  document.addEventListener('touchmove', function(e){
    if(open){ e.preventDefault(); return; }
    if(!holdTimer) return;
    var t = e.touches[0];
    /* Moving cancels the hold — a swipe is not a press. The track is already
       scrolling under the finger by this point; letting the peek also fire
       would lift a photo that is halfway between two slides. */
    if(Math.abs(t.clientX - sx) > SLOP || Math.abs(t.clientY - sy) > SLOP){
      cancelPending();
    }
  }, {passive:false});

  document.addEventListener('touchend', hide, {passive:true});
  document.addEventListener('touchcancel', hide, {passive:true});

  /* Mouse on a GRID TILE: hold to peek. Tiles have their arrows for stepping
     through shots; the hold-and-drag gesture belongs to the product page
     gallery, which is a different element and handled above. Moving the mouse
     cancels the hold, so the two never collide even where they overlap. */
  document.addEventListener('mousedown', function(e){
    if(e.button !== 0) return;
    if(e.target.closest('[data-card-prev], [data-card-next]')) return;
    var el = e.target.closest(BT_PIC);
    if(!el) return;
    sx = e.clientX; sy = e.clientY;
    cancelPending();
    warmTimer = setTimeout(function(){ warm(el.getAttribute('data-peek')); }, WARM);
    holdTimer = setTimeout(function(){ showPeek(el); blockClick = true; }, HOLD);
  });
  document.addEventListener('mousemove', function(e){
    if(!holdTimer) return;
    if(Math.abs(e.clientX - sx) > SLOP || Math.abs(e.clientY - sy) > SLOP) cancelPending();
  });
  document.addEventListener('mouseup', hide);
  document.addEventListener('mouseleave', hide);

  /* Page scroll kills a pending peek. Track scrolling is excluded — it fires
     constantly during a swipe and would be self-defeating here. */
  window.addEventListener('scroll', function(){ cancelPending(); hide(); }, {passive:true});

  document.addEventListener('click', function(e){
    if(!blockClick) return;
    if(e.target.closest(BT_TILE)){
      e.preventDefault();
      e.stopPropagation();
    }
    blockClick = false;
  }, true);

  /* iOS raises the save-image sheet on a long press — the same gesture the
     peek uses. Suppressed on tiles, and only on tiles. */
  document.addEventListener('contextmenu', function(e){
    if(e.target.closest(BT_PIC)) e.preventDefault();
  });
})();